<template>
  <v-row>
    <v-col cols="6" lg="6">
      <pie-chart
        :chartOptions="charts.onuChartMtd.chartOptions"
        chartTitle="ONU Type MTD"
        :chartWidth="480"
        :chartSeries="charts.onuChartMtd.series"
      ></pie-chart>
    </v-col>
    <v-col cols="6" lg="6">
      <pie-chart
        :chartOptions="charts.onuChartOverall.chartOptions"
        chartTitle="ONU Type Overall"
        :chartWidth="480"
        :chartSeries="charts.onuChartOverall.series"
      ></pie-chart>
    </v-col>
  </v-row>
</template>

<script>
import PieChart from "../PieChart.vue";
import ShareableMethods from "@/mixins/ShareableMethods";
export default {
  components: { PieChart },
  mixins: [ShareableMethods],
  data() {
    return {
      charts: {
        onuChartMtd: {
          series: [],
          chartOptions: {
            labels: [],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 300,
                  },
                },
              },
            ],
            legend: {
              position: "bottom",
            },
            noData: {
              text: "Loading...",
            },
            tooltip: {
              y: {
                formatter: function(value) {
                  return value.toLocaleString();
                },
              },
            },
          },
        },
        onuChartOverall: {
          series: [],
          chartOptions: {
            labels: [],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 300,
                  },
                },
              },
            ],
            legend: {
              position: "bottom",
            },
            noData: {
              text: "Loading...",
            },
            tooltip: {
              y: {
                formatter: function(value) {
                  return value.toLocaleString();
                },
              },
            },
          },
        },
      },
    };
  },
  methods: {
    async getOnuTypeMtd() {
      await this.$api
        .get(`/acquisition/report?report=distibutor-onu-type-mtd`)
        .then((response) => {
          // this.loadingData = false;
          const res = response.data.data;
          console.log(res.list);
          res.list.map((val) => {
            this.charts.onuChartMtd.series.push(val.total);
            this.charts.onuChartMtd.chartOptions.labels.push(val.label);
          });
        })
        .catch((e) => {
          // this.loadingData = false;
          console.log(e);
        });
    },

    async getOnuTypeOverall() {
      await this.$api
        .get(`/acquisition/report?report=distibutor-onu-type-overall`)
        .then((response) => {
          // this.loadingData = false;
          const res = response.data.data;
          console.log(res.list);
          res.list.map((val) => {
            this.charts.onuChartOverall.series.push(val.total);
            this.charts.onuChartOverall.chartOptions.labels.push(val.label);
          });
        })
        .catch((e) => {
          // this.loadingData = false;
          console.log(e);
        });
    },
  },

  async created() {
    this.getOnuTypeMtd();
    this.getOnuTypeOverall();
  },
};
</script>
